import React from 'react';

/**
 * DonationsPageSEO Component
 * Premium SEO optimization for hardware donation page
 * Optimized for charitable giving and community impact keywords
 */
function DonationsPageSEO() {
  React.useEffect(() => {
    // Set the page title for SEO - focused on hardware donations
    document.title = 'Donate Hardware | Transform Lives Through Technology';
    
    // Create or update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = 
      'Donate your unused hardware to bridge the digital divide. Transform lives by providing technology access to underserved communities worldwide. Every device creates learning opportunities.';
    
    // Create or update meta keywords
    let metaKeywords = document.querySelector('meta[name="keywords"]');
    if (!metaKeywords) {
      metaKeywords = document.createElement('meta');
      metaKeywords.name = 'keywords';
      document.head.appendChild(metaKeywords);
    }
    metaKeywords.content = 
      'donate hardware, computer donation, laptop donation, technology donation, digital divide, donate tech, hardware charity, computer charity, bridge digital gap, technology access, donate electronics, charitable giving, community impact';

    // Add open graph tags for social media sharing
    const ogTags = [
      { property: 'og:title', content: 'Donate Hardware | Transform Lives Through Technology' },
      { property: 'og:description', content: 'Bridge the digital divide by donating your unused hardware. Create learning opportunities for underserved communities worldwide. Every device transforms lives.' },
      { property: 'og:type', content: 'website' },
      { property: 'og:url', content: window.location.href },
      { property: 'og:image', content: '/images/hardware-donation-impact.jpg' },
      { property: 'og:site_name', content: 'Bridge Digital Divide' },
      { property: 'og:locale', content: 'en_GB' }
    ];
    
    ogTags.forEach(tag => {
      let element = document.querySelector(`meta[property="${tag.property}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('property', tag.property);
        document.head.appendChild(element);
      }
      element.content = tag.content;
    });

    // Add Twitter card tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: 'Donate Hardware | Transform Lives Through Technology' },
      { name: 'twitter:description', content: 'Bridge the digital divide by donating your unused hardware. Create learning opportunities for communities worldwide.' },
      { name: 'twitter:image', content: '/images/hardware-donation-impact-twitter.jpg' },
      { name: 'twitter:site', content: '@bridgedigitaldivide' },
      { name: 'twitter:creator', content: '@bridgedigitaldivide' }
    ];
    
    twitterTags.forEach(tag => {
      let element = document.querySelector(`meta[name="${tag.name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute('name', tag.name);
        document.head.appendChild(element);
      }
      element.content = tag.content;
    });
    
    // Add structured data for charitable organization
    let scriptStructuredData = document.querySelector('#structured-data');
    if (!scriptStructuredData) {
      scriptStructuredData = document.createElement('script');
      scriptStructuredData.id = 'structured-data';
      scriptStructuredData.type = 'application/ld+json';
      document.head.appendChild(scriptStructuredData);
    }
    
    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'CharitableOrganization',
      name: 'Bridge Digital Divide',
      url: window.location.origin,
      logo: `${window.location.origin}/images/bridge-digital-divide-logo.png`,
      description: 'Bridge Digital Divide transforms lives by connecting unused hardware with underserved communities worldwide, creating educational opportunities and digital access.',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'Global'
      },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'donations',
        email: 'donate@bridgedigitaldivide.org'
      },
      missionCoverageTier: 'Global',
      nonprofitStatus: 'Charitable'
    };
    
    scriptStructuredData.textContent = JSON.stringify(structuredData);

    // Cleanup function
    return () => {
      document.title = 'Bridge Digital Divide';
    };
  }, []);
  
  return null;
}

export default DonationsPageSEO;
